/*
 * action 类型
 */
import * as types from '../constants/ActionTypes';

function setLoginStatus(islogin){
	return {
		type:types.IS_LOGIN,
		islogin
	}
}
function setLanguage(language){
	return {
		type:types.Language,
		language
	}
}

export function islogin(islogin){
	return dispatch=>{
		dispatch(setLoginStatus(islogin));	
	}
}
export function language(language){
	return dispatch=>{
		dispatch(setLanguage(language));	
	}
}


// WEBPACK FOOTER //
// ./public/actions/CommonAction.js